import { Component } from '@angular/core';

@Component({
	selector: 'AcceptTermsComponent',
	templateUrl: './accept-terms.component.html',
	styleUrls: ['./accept-terms.component.css']
})
export class AcceptTermsComponent { }